export default {
    // 更改 currentPage 的值
    putcurrentPage (state, message) {
        state.currentPage = message
    },
    putprogrammePage (state, message) {
        state.programmePage = message
    },
    putpresentationPage (state, message) {
        state.presentationPage = message
    },
    putJournalismPage (state, message) {
        state.JournalismPage = message
    },
    putAboutUSPage (state, message) {
        state.AboutUSPage = message
    },
    putservicePage (state, message) {
        state.servicePage = message
    },
    putpresentationIds (state, message) {
        state.presentationIds = message
    },
}